/**
 * Author: SCS (Santosh Chandra Shekhar)
 * ***scs***
 */

import React, { useContext, useState } from "react";
import "./Services.css";
import Card from "../Card/Card";
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import Resume from './resume.pdf';
import {Link} from 'react-scroll'

const Services = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const [showModal, setShowModal] = useState(false);
  const [showToast, setShowToast] = useState(false);

  // transition
  const transition = {
    duration: 1,
    type: "spring",
  };

  const handleDownloadClick = () => {
    setShowModal(true);
  };

  const handleConfirmDownload = () => {
    setShowModal(false);
    
    // Create a temporary anchor element to trigger download
    const link = document.createElement('a');
    link.href = Resume;
    link.download = 'Santosh_Chandra_Shekhar_Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Show success toast
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };

  const handleCancelDownload = () => {
    setShowModal(false);
  };

  return (
    <div className="services" id="services">
      {/* Confirmation Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Download Resume</h3>
            <p>Are you sure you want to download the CV?</p>
            <div className="modal-buttons">
              <button onClick={handleConfirmDownload} className="button modal-yes">
                Yes
              </button>
              <button onClick={handleCancelDownload} className="button modal-no">
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast Notification */}
      {showToast && (
        <div className="toast-notification">
          <span>✓ Download successful!</span>
        </div>
      )}

      {/* left side */}
      <div className="awesome">
        {/* dark mode */}
        <span style={{ color: darkMode ? "white" : "" }}> My Amazing</span>
        <span>Services</span>
        <spane>
        As a Website Developer, we provide all the services <br />needed to create an awesome website.
        Our team of experts<br/> are experienced in website design, development, maintenance,<br /> and optimization.
        </spane>
        <button onClick={handleDownloadClick} className="button button1 s-button mob_pos">
          Download CV
        </button>
        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
      {/* right */}
      <div className="cards">
        {/* first card */}
        <motion.div
          initial={{ left: "25rem" }}
          whileInView={{ left: "14rem" }}
          transition={transition}
        >
          <Card
            emoji={HeartEmoji}
            heading={"Design"}
            detail={"Figma, Sketch, Photoshop, Adobe Illustrator, Zepline"}
          />
        </motion.div>
        {/* second card */}
        <motion.div
          initial={{ left: "-11rem", top: "14rem" }}
          whileInView={{ left: "-4rem" }}
          transition={transition}
        >
          <Card
            emoji={Glasses}
            heading={"Developer"}
            detail={"Html, Css, JavaScript, React, Nodejs, Express"}
          />
        </motion.div>
        {/* 3rd */}
        <motion.div
          initial={{ top: "19rem", left: "25rem" }}
          whileInView={{ left: "12rem" }}
          transition={transition}
        >
          <Card
            emoji={Humble}
            heading={"UI/UX"}
            detail={"Frontend Developer with high level of experience in web designing and development"}
            color="rgba(252, 166, 31, 0.45)"
          />
        </motion.div>
        <div
          className="blur s-blur2"
          style={{ background: "var(--purple)" }}
        ></div>
      </div>
    </div>
  );
};

export default Services;
